import {token, user} from "@/api";
import {getToken, removerToken, saveToken} from "@/utils/cache";
import router from "@/router";
import {Message} from "element-ui";

const getDefaultState = () => {
    return {
        token: getToken(),
        userinfo: {},
    }
}

const state = getDefaultState()

const mutations = {
    RESET_STATE: (state) => {
        Object.assign(state, getDefaultState())
    },
    SET_TOKEN: (state, token) => {
        state.token = token
        saveToken(token)
    },
    SET_USERINFO: (state, userinfo) => {
        Object.assign(state.userinfo, userinfo)
    },

}

const actions = {
    // 账号密码或验证码登录
    login({commit}, payload) {
        return new Promise((resolve, reject) => {
            let {type, data} = payload
            if (type == 0) {
                user.accountLogin(data).then(res => {
                    let {data} = res
                    // commit("SET_USERINFO", data.userinfo)
                    commit("SET_TOKEN", data.userinfo.token)
                    commit("SET_USERINFO", data.userinfo)
                    resolve()
                }).catch((error) => {
                    reject(error)
                })
            } else {
                user.mobileLogin(data).then(res => {
                    let {data} = res
                    // commit("SET_USERINFO", data.userinfo)
                    commit("SET_TOKEN", data.userinfo.token)
                    resolve()
                }).catch((error) => {
                    reject(error)
                })
            }
        })
    },

    /**
     * 判断是否登录
     */
    checkToken() {
        return new Promise((resolve, reject) => {
            token.check().then(res => {
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },
    resetToken({commit}) {
        return new Promise(resolve => {
            removerToken()
            commit('RESET_STATE')
            resolve()
        })
    },
    logout({commit}) {
        return new Promise((resolve, reject) => {
            user.logout().then(() => {
                commit('RESET_STATE')
                removerToken()
                router.push('/login')
                resolve()
            }).catch(error => {
                reject(error)
            })

        })

    }

}

export default {
    state,
    mutations,
    actions,
    namespaced: true,
}
